<template>
  <div class="wrap">
    <div class="main layout">
      <Row>
        <Col span="12">
        <img class="bg"
             src="../assets/images/login/img_login.png"
             style="height: 500px;"
             alt="">
        </Col>
        <Col span="12">
        <div class="login-form">
          <img v-if="pageType===1"
               @click="toggleLoginWay"
               class="login-person"
               src="../assets/images/login/img_login_person.png"
               alt="">
          <img v-else
               class="login-person"
               src="../assets/images/login/img_login_person1.png"
               alt="">
          <template v-if="way">
            <h3 class="login-title">手机验证码{{ pageType===1 ? '登录':'注册'}}</h3>
            <div>
              <div class="item-box"
                   style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                <Input class="inputs"
                       type="text"
                       placeholder="请输入您的手机号"
                       v-model="phoneNumber"
                       @on-keyup="typingNumber"
                       style="width:275px">
                <img slot="prepend"
                     src="../assets/images/login/call-in.png">
                </Input>
                <Button class="codeBtn"
                        :class="codes.disabled ? '' : ''"
                        type="primary"
                        @click="getCode"
                        :disabled="codes.disabled">{{btnText}}</Button>
              </div>
              <div style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                <Input class="inputs"
                       type="text"
                       placeholder="请输入验证码"
                       v-model="phoneCode"
                       @on-keyup="typingCode">
                <img slot="prepend"
                     src="../assets/images/login/account.png">
                </Input>
              </div>
              <Button class="login-btn"
                      :class="!subBtn ? 'login-avaliable' : 'login-disabled'"
                      :disabled="subBtn"
                      @click="logIn">{{pageType===1?'登录':'注册'}}</Button>
              <div class="text-center"
                   v-if="pageType===1">
                <div style="margin-top: 20px;">
                  <img @click="weixinLogin"
                       style="cursor:pointer"
                       src="../assets/images/login/vx.png"
                       alt="">
                  <span style="color: #aaa;margin-left: 10px;">微信登录</span>
                  <img @click="toggleLoginWay"
                       style="cursor:pointer;width: 50px;height: 50px;margin-left: 40px"
                       src="../assets/images/login/mma.jpg"
                       alt="">
                  <span style="color: #aaa;margin-left: 10px;">密码登录</span>
                </div>
              </div>

            </div>
          </template>
          <template v-else>
            <template v-if="pageType ===1">
              <h3 class="login-title">账号密码{{ pageType===1 ? '登录':'注册'}}</h3>
              <div>
                <div style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                  <Input class="inputs"
                         type="text"
                         placeholder="请输入您的手机号"
                         v-model="phoneNumber"
                         @on-keyup="typingNumber">
                  <img slot="prepend"
                       src="../assets/images/login/call-in.png">
                  </Input>
                </div>
                <div style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                  <Input class="inputs"
                         type="password"
                         placeholder="请输入密码"
                         v-model="password"
                         @on-keyup="typingPassword">
                  <img slot="prepend"
                       src="../assets/images/login/account.png">
                  </Input>
                </div>
                <Button class="login-btn "
                        :class="!subBtn2 ? 'login-avaliable' : 'login-disabled'"
                        :disabled="subBtn2"
                        @click="logIn2">{{pageType===1?'登录':'注册'}}</Button>
                <div class="text-center"
                     v-if="pageType===1">
                  <div style="margin-top: 20px;">
                    <img @click="weixinLogin"
                         style="cursor:pointer"
                         src="../assets/images/login/vx.png"
                         alt="">
                    <span style="color: #aaa;margin-left: 10px">微信登录</span>
                    <img @click="toggleLoginWay"
                         style="cursor:pointer;width: 50px;height: 50px;margin-left: 40px"
                         src="../assets/images/login/yzm.jpg"
                         alt="">
                    <span style="color: #aaa;margin-left: 10px;">短信登录</span>
                  </div>
                </div>
              </div>
            </template>
            <temalate v-else>
              <h3 class="login-title">手机验证码{{ pageType===1 ? '登录':'注册'}}</h3>
              <div>
                <div class="item-box"
                     style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                  <Input class="inputs"
                         type="text"
                         placeholder="请输入您的手机号"
                         v-model="phoneNumber"
                         @on-keyup="typingNumber"
                         style="width:275px">
                  <img slot="prepend"
                       src="../assets/images/login/call-in.png">
                  </Input>
                  <Button class="codeBtn"
                          :class="codes.disabled ? '' : ''"
                          type="primary"
                          @click="getCode"
                          :disabled="codes.disabled">{{btnText}}</Button>
                </div>
                <div style="border: 2px solid #ddd;border-radius: 4px;margin-bottom: 25px;">
                  <Input class="inputs"
                         type="text"
                         placeholder="请输入验证码"
                         v-model="phoneCode"
                         @on-keyup="typingCode">
                  <img slot="prepend"
                       src="../assets/images/login/account.png">
                  </Input>
                </div>
                <Button class="login-btn"
                        :class="!subBtn ? 'login-avaliable' : 'login-disabled'"
                        :disabled="subBtn"
                        @click="logIn">{{pageType===1?'登录':'注册'}}</Button>
                <div class="text-center"
                     v-if="pageType===1">
                  <div style="margin-top: 20px;">
                    <img @click="weixinLogin"
                         style="cursor:pointer"
                         src="../assets/images/login/vx.png"
                         alt="">
                    <span style="color: #aaa;margin-left: 10px;">微信登录</span>
                    <img @click="toggleLoginWay"
                         style="cursor:pointer;width: 50px;height: 50px;margin-left: 40px"
                         src="../assets/images/login/mma.jpg"
                         alt="">
                    <span style="color: #aaa;margin-left: 10px;">密码登录</span>
                  </div>
                </div>

              </div>
            </temalate>

          </template>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import axios from '@/api/axios.js';
import * as apis from '@/api/login.js';
import { mapState } from 'vuex'
import { verifyPhone } from '../../public/js/util.js';
import { setInterval, clearInterval } from 'timers';
import { setLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      phoneNumber: '',
      phoneCode: '',
      password: '',
      btnText: '获取验证码',
      codes: {
        disabled: true,
        time: 10,
        timer: null,
      },
      subBtn: true,
      subBtn2: true,
      way: true,
      pageType: 1, //1登录 2注册
      flagLogin: false
    }
  },
  computed: {
    ...mapState({
      flag: state => state.loginState,
      mail: state => state.mail
    }),
    sendCode () {
      if (!this.codes.disabled) {
        return this.countBackwordNumber(this.codes);
      } else {
        return this.codes;
      }
    }
  },
  created () {
    this.pageType = Number(this.$route.params.type)
  },
  mounted () {
    let query = this.$route.query;
    if (Object.keys(query).length > 0) {
      this.sendCodeToLogin(query.code, query.state);
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(localStorage.getItem('routePath'))
      if (!localStorage.getItem('routePath')) {
        localStorage.setItem('routePath', from.path)
      }
    })
  },
  destroyed () {
    localStorage.setItem('routePath', '')
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          this.pageType = Number(this.$route.params.type)
          this.phoneNumber = ''
          this.phoneCode = ''
          this.password = ''
        })
      },
      deep: true
    }
  },
  methods: {
    weixinLogin () {
      // let redirect_uri = encodeURIComponent('http://admin.weimajie.com.cn/api/v1/web/register/wechat/login')
      let redirect_uri = encodeURIComponent('http://weimajie.com.cn/login/1');
      window.location.replace("https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_login&code=021ve3rA1c6e4a0DdDrA1z6drA1ve3rc&state=STATE#wechat_redirect")
      let str = "https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
      var obj = new WxLogin({
        id: "qrCode",
        appid: "wx6842a7f406c7d13f",
        scope: "snsapi_login",
        redirect_uri: "",
        href: '',
        state: ""
      });
    },
    async sendCodeToLogin (code, state) {
      let data = {
        code, state
      };
      let res = await apis.sendCodeToLogin(data);
      if (res.code == 222) {
        this.$Message.error(res.data.msg[0]);
        localStorage.setItem('code', 222);
        // 取消微信注册
        this.$router.push('/login/2');
      } else if (res.code == 200) {
        let token = res.data.token;
        setLocalStorage('loginState', true)
        setLocalStorage('token', token)
        localStorage.setItem('time', new Date().getTime());
        this.$store.commit('LOGIN_STATE', true)
        this.getLoginOnPersonInfo(token);
      }
      // if(res.code == 200){

      // }
    },
    toggleLoginWay () {
      this.phoneNumber = '';
      this.phoneCode = '';
      this.password = '';
      let way = this.way;
      this.way = !way;
      this.phoneNumber = ''
      this.phoneCode = ''
      this.password = ''
    },
    countBackwordNumber (obj) {
      const TIME_COUNT = 60;
      if (!obj.timer) {
        obj.time = TIME_COUNT;
        obj.disabled = false;
        obj.timer = setInterval(() => {
          if (obj.time > 0 && obj.time <= TIME_COUNT) {
            obj.time--;
            this.btnText = obj.time + 's后重新获取';
            obj.disabled = true;
          } else {
            obj.disabled = false;
            clearInterval(obj.timer);
            this.btnText = '获取验证码';
            obj.timer = null;
          }
        }, 1000);
      }
      return {
        timer: obj.timer,
        disabled: obj.disabled,
        time: obj.time
      }
    },
    getCode () {

      let phone = this.phoneNumber;
      let flag = verifyPhone(phone);
      if (!flag) {
        this.$Message.error('手机号格式不正确！');
        return false;
      }
      this.countBackwordNumber(this.codes);
      let data = {
        phone: phone
      };
      axios({
        method: "post",
        url: '/api/v1/web/register/mobile/login/code',
        headers: {
          Authorization: "Basic ZW9sOmVvbFNlY3JldA=="
        },
        data: data
      }).then(res => {
        if (res.code == 200) {
          this.$Message.success({
            content: res.data.mobile,
            duration: 3
          });
        } else {
          this.$Message.error({
            content: res.data.msg[0],
            duration: 3
          });
        }
      }).catch(e => {
        console.log(e);
      });
      // let res = await apis.getCodeOnRegist(data);


    },
    typingNumber () {  //输入手机号
      let phone = this.phoneNumber;
      let flag = verifyPhone(phone);
      if (flag) {
        this.codes.disabled = false
      } else {
        this.codes.disabled = true
      }
    },
    typingCode () {  //输入验证码
      if (this.phoneCode.length > 0 && this.phoneNumber.length == 11) {
        this.subBtn = false;
      } else {
        this.subBtn = true;
      }
    },
    typingPassword () {  //输入验证码
      if (this.phoneNumber.length > 0 && this.password.length > 0) {
        this.subBtn2 = false;
      } else {
        this.subBtn2 = true;
      }
    },
    getLoginOnPersonInfo (token) {
      this.$store.commit('MAIL', !this.mail);
      //登陆后查看个人信息完成度，做响应跳转
      axios({
        method: "get",
        url: '/api/v1/web/auth/get_info',
        headers: {
          Authorization: token
        },
        data: {}
      }).then(rs => {
        if (rs.code == 200) {
          if (rs.data.enabled == 1) {
            // 跳转登录前的页面
            localStorage.setItem('username', rs.data.name || '')
            if (localStorage.getItem('routePath') && localStorage.getItem('routePath') != '/') {
              this.getHistoryRoute()
            } else {
              // this.$router.go(-1);
              this.$router.push('/home');
            }
          } else {
            this.$router.push('/perfectInfo');
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    logIn () {
      //手机验证码登录
      if (this.flagLogin) return;
      this.flagLogin = true;
      let data = {
        phone: this.phoneNumber,
        code: this.phoneCode
      }
      axios({
        method: "post",
        url: '/api/v1/web/register/sms/login',
        headers: {
          Authorization: "Basic ZW9sOmVvbFNlY3JldA=="
        },
        data: data
      }).then(res => {
        let token = null;
        if (res.code == 200) {
          token = res.data.token;
          setLocalStorage('token', token)
          setLocalStorage('loginState', true)
          localStorage.setItem('time', new Date().getTime());
          this.$store.commit('LOGIN_STATE', true);
          //获取个人信息
          this.getLoginOnPersonInfo(token);
        } else {
          let str = res.msg;
          this.$Message.error(str)
        }
        setTimeout(() => {
          this.flagLogin = false;
        }, 1000)
      }).catch(e => {
        this.flagLogin = false;
        console.log(e);
      });
    },
    logIn2 () {
      //账号密码登录
      if (this.flagLogin) return;
      this.flagLogin = true;
      let data = {
        account: this.phoneNumber,
        password: this.password
      }
      axios({
        method: "post",
        url: '/api/v1/web/register/login',
        headers: {
          Authorization: "Basic ZW9sOmVvbFNlY3JldA=="
        },
        data: data
      }).then(res => {
        let token = null;
        if (res.code == 200) {
          token = res.data.token;
          setLocalStorage('token', token)
          setLocalStorage('loginState', true)
          localStorage.setItem('time', new Date().getTime());
          this.$store.commit('LOGIN_STATE', true)
          //获取个人信息
          this.getLoginOnPersonInfo();
        } else {
          if(res.code == 422) {
            this.$Message.error('您的用户名或密码不正确')
          } else {
            let str = res.msg;
            this.$Message.error(str)
          }
        }
        setTimeout(() => {
          this.flagLogin = false;
        }, 1000)
      }).catch(e => {
        this.flagLogin = false;
        console.log(e)
      })
    },
    async getUserInfo () {
      //获取个人信息，用户名
      try {
        let res = await apis.getUserInfoData({});
        if (res.code == 200) {
          if (res.data.enabled == 1) {
            // 跳转登录前的页面
            localStorage.setItem('username', res.data.name || '')
            if (localStorage.getItem('routePath') && localStorage.getItem('routePath') != '/') {
              this.getHistoryRoute()
            } else {
              this.$router.push('/home');
            }
          } else {
            this.$router.push('/perfectInfo');
          }

        }
      } catch (e) {

        console.log(e)
      }

    },
    // 获取历史路由跳转
    getHistoryRoute () {
      let name = localStorage.getItem('routePath') + ''
      this.$router.push(name)
      localStorage.setItem('routePath', '')
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  width: 970px;
  margin: 0 auto;
}
.main {
  margin: 80px auto 175px;
}
.bg {
  width: 100%;
}
.login-form {
  position: relative;
  height: 500px;
  background: #fff;
  border-radius: 0 0 8px 0;
  padding: 0 36px;
}
.login-person {
  position: absolute;
  right: 0;
  top: 0;
  background: #f4f4f4;
}
.login-title {
  font-size: 30px;
  font-weight: normal;
  color: #ac4126;
  line-height: 90px;
  margin-bottom: 28px;
}
.login-btn {
  width: 100%;
  height: 50px;
  background: #ccc;
  color: #fff;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  border: none;
  border-radius: 4px;
  margin-bottom: 50px;
}
.login-avaliable {
  background: #ac4126;
}
.login-avaliable:hover {
  background: #ac4126;
  color: #fff;
}
.login-disabled {
  background: #ccc;
}
.ivu-input-group {
  display: inline-table;
  top: 0;
}
.item-box {
  position: relative !important;
}
</style>
<style>
.codeBtn {
  position: absolute !important;
  top: -2px !important;
  right: -2px !important;
  width: 140px;
  height: 44px;
  background: #ac4126;
  color: #fff;
  font-size: 18px;
  border: none !important;
  vertical-align: top;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 2px solid #ddd !important;
}
.codeBtn:disabled {
  height: 40px !important;
  top: 0 !important;
  right: 0 !important;
}
.ivu-btn-primary {
  /* border: 2px solid #b43023 !important; */
}
.inputs .ivu-input {
  height: 50px;
  /*background-color: #f4f4f4;*/
  /* border: 1px solid #ddd; */
  /* border-left: 0; */
  border: none;
  font-size: 18px;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.inputs .ivu-input:hover {
  border-color: #ddd;
}
.inputs .ivu-input-search {
  background: #ac4126 !important;
  border-color: #ac4126 !important;
}
.inputs .ivu-input-search:hover {
  background: #ac4126 !important;
  border-color: #ac4126 !important;
}
.inputs.ivu-input-with-search:hover .ivu-input {
  border-color: #ddd;
}
.inputs .ivu-input-group-append,
.inputs .ivu-input-group-prepend {
  background-color: #f4f4f4;
  border: none;
}
.ivu-divider-inner-text {
  color: #aaa;
}
</style>
